module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nmodel.meta = model.meta || {};\nvar title = model.meta.title || model.name || model.nameSEO || __(\"error:unknownPageTitle\");\nmodel.meta.title = title;\n%><!-- LAYOUTS/MASTER/MASTER -->\n<html lang=\"<%= model.lang %>\">\n<head>\n<!-- meta tags -->\n<title><%= title %></title>\n<meta name=\"viewport\" content=\"width=device-width, user-scalable=no, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0\">\n<% utils.forEach(model.meta, function(metaContent, metaName){ %>\n<meta name=\"<%= metaName %>\" content=\"<%= metaContent %>\" />\n<% }); %>\n<!-- IBT favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicons/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicons/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicons/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicons/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicons/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicons/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicons/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicons/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicons/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\" href=\"/favicons/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicons/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicons/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicons/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicons/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicons/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<meta name=\"robots\" content=\"index,follow\">\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=<%- model.upStartTimestamp || '-' %>\" />\n</head>\n<body class=\"<%= model.bodyClass || '' %> <%= environment.style || '' %> <%- (environment.device && environment.device.type ? 'device-' + environment.device.type : '') %> <%- (environment.breakPoint ? 'breakPoint-' + environment.breakPoint : '') %>\">\n<!-- content -->\n<div class=\"environmentMeasurement\"></div>\n<%- helpers.renderSection('main'); %>\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nwindow.route \t\t\t\t= \"<%= model.route || '' %>\";\nwindow.tree \t\t\t\t= <%- model.tree || 'null' %>;\nwindow.updateClientStorage \t= <%- model.updateClientStorage || 'null' %>;\nwindow.routeParams \t\t\t= <%- model.routeParams || {} %>;\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=<%- model.upStartTimestamp || '-' %>\"></script>\n<%- include('../../templates/headPanel/sidePanels/contactFormSuccess'); %>\n<%- include('../../templates/headPanel/sidePanels/contactFormError'); %>\n</body>\n</html>"
  , __filename = "components/layouts/master/master.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
model.meta = model.meta || {};
var title = model.meta.title || model.name || model.nameSEO || __("error:unknownPageTitle");
model.meta.title = title;

    ; __line = 5
    ; __append("<!-- LAYOUTS/MASTER/MASTER -->\n<html lang=\"")
    ; __line = 6
    ; __append(escapeFn( model.lang ))
    ; __append("\">\n<head>\n<!-- meta tags -->\n<title>")
    ; __line = 9
    ; __append(escapeFn( title ))
    ; __append("</title>\n<meta name=\"viewport\" content=\"width=device-width, user-scalable=no, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0\">\n")
    ; __line = 11
    ;  utils.forEach(model.meta, function(metaContent, metaName){ 
    ; __append("\n<meta name=\"")
    ; __line = 12
    ; __append(escapeFn( metaName ))
    ; __append("\" content=\"")
    ; __append(escapeFn( metaContent ))
    ; __append("\" />\n")
    ; __line = 13
    ;  }); 
    ; __append("\n<!-- IBT favicons -->\n<link rel=\"apple-touch-icon\" sizes=\"57x57\" href=\"/favicons/apple-icon-57x57.png\">\n<link rel=\"apple-touch-icon\" sizes=\"60x60\" href=\"/favicons/apple-icon-60x60.png\">\n<link rel=\"apple-touch-icon\" sizes=\"72x72\" href=\"/favicons/apple-icon-72x72.png\">\n<link rel=\"apple-touch-icon\" sizes=\"76x76\" href=\"/favicons/apple-icon-76x76.png\">\n<link rel=\"apple-touch-icon\" sizes=\"114x114\" href=\"/favicons/apple-icon-114x114.png\">\n<link rel=\"apple-touch-icon\" sizes=\"120x120\" href=\"/favicons/apple-icon-120x120.png\">\n<link rel=\"apple-touch-icon\" sizes=\"144x144\" href=\"/favicons/apple-icon-144x144.png\">\n<link rel=\"apple-touch-icon\" sizes=\"152x152\" href=\"/favicons/apple-icon-152x152.png\">\n<link rel=\"apple-touch-icon\" sizes=\"180x180\" href=\"/favicons/apple-icon-180x180.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"192x192\" href=\"/favicons/android-icon-192x192.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"32x32\" href=\"/favicons/favicon-32x32.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"96x96\" href=\"/favicons/favicon-96x96.png\">\n<link rel=\"icon\" type=\"image/png\" sizes=\"16x16\" href=\"/favicons/favicon-16x16.png\">\n<link rel=\"manifest\" href=\"/favicons/manifest.json\">\n<meta name=\"msapplication-TileColor\" content=\"#ffffff\">\n<meta name=\"msapplication-TileImage\" content=\"/favicons/ms-icon-144x144.png\">\n<meta name=\"theme-color\" content=\"#ffffff\">\n<meta name=\"robots\" content=\"index,follow\">\n<!-- css sources -->\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/vendors~app.css?usTS=")
    ; __line = 34
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n<link type=\"text/css\" rel=\"stylesheet\" href=\"/webpack/css/app.css?usTS=")
    ; __line = 35
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\" />\n</head>\n<body class=\"")
    ; __line = 37
    ; __append(escapeFn( model.bodyClass || '' ))
    ; __append(" ")
    ; __append(escapeFn( environment.style || '' ))
    ; __append(" ")
    ; __append( (environment.device && environment.device.type ? 'device-' + environment.device.type : '') )
    ; __append(" ")
    ; __append( (environment.breakPoint ? 'breakPoint-' + environment.breakPoint : '') )
    ; __append("\">\n<!-- content -->\n<div class=\"environmentMeasurement\"></div>\n")
    ; __line = 40
    ; __append( helpers.renderSection('main') )
    ; __append("\n<!-- js server sources -->\n<script type=\"application/javascript\" class=\"dynamicJSSources\">\nwindow.route 				= \"")
    ; __line = 43
    ; __append(escapeFn( model.route || '' ))
    ; __append("\";\nwindow.tree 				= ")
    ; __line = 44
    ; __append( model.tree || 'null' )
    ; __append(";\nwindow.updateClientStorage 	= ")
    ; __line = 45
    ; __append( model.updateClientStorage || 'null' )
    ; __append(";\nwindow.routeParams 			= ")
    ; __line = 46
    ; __append( model.routeParams || {} )
    ; __append(";\n</script>\n<!-- js sources -->\n<script type=\"text/javascript\" src=\"/webpack/js/vendors~app.js?usTS=")
    ; __line = 49
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n<script type=\"text/javascript\" src=\"/webpack/js/app.js?usTS=")
    ; __line = 50
    ; __append( model.upStartTimestamp || '-' )
    ; __append("\"></script>\n")
    ; __line = 51
    ; __append( include('../../templates/headPanel/sidePanels/contactFormSuccess') )
    ; __append("\n")
    ; __line = 52
    ; __append( include('../../templates/headPanel/sidePanels/contactFormError') )
    ; __append("\n</body>\n</html>")
    ; __line = 54
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/layouts/master/master.ejs

}